import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AgencyLoginGroup } from 'src/app/app.model';
import { AgencyLoginAccessService } from '../../services/agency-login-access.service';

@Component({
	selector: 'app-agency-login-access',
	templateUrl: './agency-login-access.component.html',
	styleUrls: ['./agency-login-access.component.css']
})
export class AgencyLoginAccessComponent implements OnInit {

	@Input() agencyUuid!: string;
	@Input() agencyName!: string;

	error!: string;
	loading: boolean = false;
	groups: AgencyLoginGroup[] = [];
	blockedOnLoad: string[] = [];

	constructor(
		private agencyLoginAccessService: AgencyLoginAccessService,
		private activeModalService: NgbActiveModal,
	) { }

	ngOnInit(): void {
		this.getLoginAccess();
	}

	getLoginAccess() {
		this.loading = true;
		this.agencyLoginAccessService.getLoginAccess(this.agencyUuid).subscribe(res => {
			this.groups = res.data;
			this.blockedOnLoad = this.groups.filter(group => group.disabled).map(group => group.key);
			this.loading = false;
		}, error => {
			this.loading = false;
			this.error = error;
		});
	}

	get allDisabled(): boolean {
		return this.groups.length > 0 && this.groups.every(group => group.disabled);
	}

	toggleAll(event: any) {
		this.groups.forEach(group => group.disabled = event.target.checked);
	}

	confirmOnBlock(): boolean {
		const newlyBlocked = this.groups.filter(group => group.disabled && !this.blockedOnLoad.includes(group.key));
		if (newlyBlocked.length === 0) {
			return true;
		}
		const labels = newlyBlocked.map(group => group.label).join(', ');
		return confirm(`Block sign-in for ${labels} at "${this.agencyName}"? Anyone from ${labels} who is currently signed in will be logged out immediately.`);
	}

	onSubmit() {
		if (!this.confirmOnBlock()) {
			return;
		}
		this.error = '';
		this.loading = true;
		const groups: { [key: string]: boolean } = {};
		this.groups.forEach(group => groups[group.key] = group.disabled);
		this.agencyLoginAccessService.updateLoginAccess(this.agencyUuid, groups).subscribe(res => {
			this.loading = false;
			this.activeModalService.close({ refresh: true });
		}, error => {
			this.loading = false;
			this.error = error;
		});
	}

	onClose() {
		this.activeModalService.close();
	}
}
